// extracted by mini-css-extract-plugin
export default {"cta":"pH-z","disabled":"qH-z"};